<template>
  <div class="card-wrapper">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>

<script>
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain },
  props: { expoMeetingCode: { type: String, default: '' } },
  data() {
    return {
      checkedRows: [],
      usePage: true,
      localTimeZone: '',
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  created() {
    this.getData({})
  },
  methods: {
    async getData(form) {
      if (!this.expoMeetingCode) return
      this.loading = true
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .expoMeetingDocPageListApi({
          ...form,
          ...this.page,
          expoMeetingCode: this.expoMeetingCode,
          localTimeZone,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    cancel() {
      this.clearCheckboxRow()
      this.$emit('close')
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${offsetMinutes >= 0 ? '-' : '+'}${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
      this.$refs.main.clear
    },
    async getCheckData() {
      const listExpoMeetingDocCode = this.checkedRows.map(
        (item) => item.expoMeetingDocCode
      )
      return listExpoMeetingDocCode
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
.card-wrapper {
  background-color: #ffffff;
  border-radius: 6px;
}
</style>
